
import { defineComponent, ref, onMounted } from 'vue'

import eventService from '@/core/services/PublicService';
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "public-medals",
    setup() {
        const loading = ref(false)
        const idsport = ref<any>('')
        const listMedals = ref<any>([])
        const listSports = ref<any>([])
        const listMedallaSport = ref<any>([])


        const getListMedals = async () => {
            loading.value = true
            await eventService.Medallero('1')
                .then((res) => {
                    listMedals.value = res.data
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const getListSports = async () => {
            loading.value = true
            await eventService.options('1', 'sports')
                .then((res) => {
                    loading.value = false
                    listSports.value = res.data
                    if (res.data) {
                        idsport.value = res.data[0].idsport
                        medalleroDeporte()
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const medalleroDeporte = async () => {
            loading.value = true
            await eventService.MedalleroSport('1', idsport.value)
                .then((res) => {
                    loading.value = false
                    listMedallaSport.value = res.data.medallas
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getListMedals()
            getListSports()

        })

        return {
            loading,
            idsport,
            listMedals,
            listSports,
            listMedallaSport,
            getListMedals,
            getListSports,
            medalleroDeporte

        }

    },
})
